/** Grow a textarea to fit its content (no max row cap). */
export function resizeTextareaToContent(textarea: HTMLTextAreaElement) {
  textarea.style.height = "auto";
  textarea.style.height = `${textarea.scrollHeight}px`;
}

export const autoResizeTextareaStyles = {
  resize: "none" as const,
  overflow: "hidden" as const,
  minHeight: "auto",
};
